function buildHistory({
  fromYm,
  toYm,
  startAmount,
  monthlyStep,
  empresa,
  cuit,
  tipo = 'rel_dep'
}) {
  const out = []
  const [fromY, fromM] = fromYm.split('-').map(Number)
  const [toY, toM] = toYm.split('-').map(Number)
  const from = new Date(Date.UTC(fromY, fromM - 1, 1))
  const to = new Date(Date.UTC(toY, toM - 1, 1))
  let idx = 0
  for (let d = new Date(from); d <= to; d.setUTCMonth(d.getUTCMonth() + 1)) {
    const ym = `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}`
    const monto = Math.max(1000, Math.round(startAmount + idx * monthlyStep))
    out.push({
      periodo: ym,
      periodoISO: ym,
      empresa,
      cuit,
      monto,
      tipo,
      incluyeSac: false,
      requiereRevision: false,
      amountConfidence: 0.98,
      amountSource: 'simulation'
    })
    idx += 1
  }
  return out
}

function makePayload({ caseId, label, expediente, historialLaboral, parametros }) {
  const sortedDesc = [...(historialLaboral || [])].sort((a, b) => String(b.periodo).localeCompare(String(a.periodo)))
  const ultimoPeriodoDetectado = sortedDesc[0]?.periodo || ''
  return {
    meta: {
      caseId,
      label,
      source: 'simulation',
      createdAt: new Date().toISOString(),
      version: 'sim-v1'
    },
    expediente,
    historialLaboral: sortedDesc,
    parametros,
    parserOutput: {
      cuil: expediente.cuilCuit,
      ultimoPeriodoDetectado,
      remuneraciones: sortedDesc,
      resumenHistoriaLaboral: {
        sourceConfidence: 1,
        qualityWarning: '',
        duplicateRatio: 0
      },
      resumenHistoriaLaboralDetalle: []
    }
  }
}

function withLegalMilestones(expediente, milestones = {}) {
  return {
    ...expediente,
    fechaReclamoAdministrativo: milestones.fechaReclamoAdministrativo || '2024-03-15',
    fechaOtorgamientoBeneficio: milestones.fechaOtorgamientoBeneficio || '2024-11-10',
    fechaDenegatoriaODemanda: milestones.fechaDenegatoriaODemanda || '2025-01-20',
  }
}

const baseHistoryStable = buildHistory({
  fromYm: '2016-01',
  toYm: '2024-12',
  startAmount: 55000,
  monthlyStep: 1800,
  empresa: 'ESTUDIO JURIDICO DELTA SA',
  cuit: '30712345671'
})

const highIncomeTopes = buildHistory({
  fromYm: '2014-01',
  toYm: '2025-03',
  startAmount: 240000,
  monthlyStep: 5200,
  empresa: 'ENERGIA AUSTRAL SA',
  cuit: '30799887769'
})

const mixedDep = buildHistory({
  fromYm: '2010-01',
  toYm: '2018-12',
  startAmount: 42000,
  monthlyStep: 1300,
  empresa: 'LOGISTICA PAMPA SRL',
  cuit: '30555666779',
  tipo: 'rel_dep'
})

const mixedAuto = buildHistory({
  fromYm: '2019-01',
  toYm: '2025-03',
  startAmount: 68000,
  monthlyStep: 2100,
  empresa: 'TRABAJO AUTONOMO',
  cuit: '27222333445',
  tipo: 'autonomo'
})

const stressGaps = buildHistory({
  fromYm: '2011-01',
  toYm: '2025-03',
  startAmount: 38000,
  monthlyStep: 1700,
  empresa: 'SERVICIOS RIO PLATA SA',
  cuit: '30700111225'
}).filter((row, idx) => idx % 17 !== 0)

const dependenciaOrdinaria = buildHistory({
  fromYm: '2015-04',
  toYm: '2025-03',
  startAmount: 70000,
  monthlyStep: 2300,
  empresa: 'INDUSTRIAS DEL SUR SA',
  cuit: '30000000007',
})

const mixtoViableDep = buildHistory({
  fromYm: '2008-01',
  toYm: '2017-12',
  startAmount: 52000,
  monthlyStep: 1600,
  empresa: 'TRANSPORTES ANDINOS SA',
  cuit: '30700111225',
  tipo: 'rel_dep',
})

const mixtoViableAuto = buildHistory({
  fromYm: '2018-01',
  toYm: '2025-03',
  startAmount: 98000,
  monthlyStep: 2400,
  empresa: 'SERVICIOS PROFESIONALES',
  cuit: '27222333445',
  tipo: 'autonomo',
})

const docentePuro = buildHistory({
  fromYm: '2013-01',
  toYm: '2025-03',
  startAmount: 68000,
  monthlyStep: 2100,
  empresa: 'MINISTERIO DE EDUCACION',
  cuit: '33000000006',
  tipo: 'docente',
})

const autonomoPuro = buildHistory({
  fromYm: '2012-01',
  toYm: '2025-03',
  startAmount: 76000,
  monthlyStep: 2500,
  empresa: 'ACTIVIDAD AUTONOMA',
  cuit: '27222333445',
  tipo: 'autonomo',
})

export const SIMULATION_CASES = [
  makePayload({
    caseId: 'SIM-BASE-01',
    label: 'Dependencia estable - RIPTE base',
    expediente: withLegalMilestones({
      cuilCuit: '20123456786',
      nombre: 'Ana',
      apellido: 'Gomez',
      sexo: 'F',
      fechaNacimiento: '1965-08-14',
      fechaCese: '2025-03-01',
      haberActual: 210000,
      jurisdiccion: 'CABA_FEDERAL',
      fallo: 'RIPTE'
    }),
    historialLaboral: baseHistoryStable,
    parametros: {
      indiceObjetivo: 'RIPTE',
      metodoCalculo: 'base',
      incluirPBU: true,
      topeLegal: true
    }
  }),
  makePayload({
    caseId: 'SIM-BASE-02',
    label: 'Ingresos altos con topes legales',
    expediente: withLegalMilestones({
      cuilCuit: '20222333408',
      nombre: 'Martin',
      apellido: 'Rios',
      sexo: 'M',
      fechaNacimiento: '1962-03-22',
      fechaCese: '2025-03-01',
      haberActual: 1350000,
      jurisdiccion: 'CABA_FEDERAL',
      fallo: 'RIPTE'
    }, {
      fechaReclamoAdministrativo: '2024-04-10',
      fechaOtorgamientoBeneficio: '2024-12-02',
      fechaDenegatoriaODemanda: '2025-02-05',
    }),
    historialLaboral: highIncomeTopes,
    parametros: {
      indiceObjetivo: 'RIPTE',
      metodoCalculo: 'base',
      incluirPBU: true,
      topeLegal: true
    }
  }),
  makePayload({
    caseId: 'SIM-ADV-01',
    label: 'Mixto + moratoria probable',
    expediente: withLegalMilestones({
      cuilCuit: '27299888709',
      nombre: 'Laura',
      apellido: 'Suarez',
      sexo: 'F',
      fechaNacimiento: '1968-11-10',
      fechaCese: '2025-03-01',
      haberActual: 520000,
      jurisdiccion: 'PBA',
      fallo: 'ISBIC',
      tieneMoratoria: true
    }),
    historialLaboral: [...mixedDep, ...mixedAuto].sort((a, b) => String(b.periodo).localeCompare(String(a.periodo))),
    parametros: {
      indiceObjetivo: 'ISBIC',
      metodoCalculo: 'avanzado',
      incluirPBU: true,
      topeLegal: true,
      estrategiaJuridica: {
        habilitarFallos: true,
        tasaInteres: 'ACTIVA_BNA',
        aplicarPrescripcion: true
      }
    }
  }),
  makePayload({
    caseId: 'SIM-ADV-02',
    label: 'Historia incompleta con faltantes',
    expediente: withLegalMilestones({
      cuilCuit: '20333444519',
      nombre: 'Diego',
      apellido: 'Paz',
      sexo: 'M',
      fechaNacimiento: '1964-06-01',
      fechaCese: '2025-03-01',
      haberActual: 390000,
      jurisdiccion: 'CABA_FEDERAL',
      fallo: 'RIPTE'
    }),
    historialLaboral: stressGaps,
    parametros: {
      indiceObjetivo: 'RIPTE',
      metodoCalculo: 'avanzado',
      incluirPBU: true,
      topeLegal: true,
      estrategiaJuridica: {
        habilitarFallos: true,
        tasaInteres: 'PASIVA_BCRA_A14290',
        aplicarPrescripcion: true
      }
    }
  }),
  makePayload({
    caseId: 'SIM-ADV-03',
    label: 'Estres de variaciones y control legal',
    expediente: withLegalMilestones({
      cuilCuit: '20999000119',
      nombre: 'Sofia',
      apellido: 'Ibarra',
      sexo: 'F',
      fechaNacimiento: '1961-01-19',
      fechaCese: '2025-03-01',
      haberActual: 880000,
      jurisdiccion: 'CORDOBA',
      fallo: 'MIXTO'
    }),
    historialLaboral: buildHistory({
      fromYm: '2009-01',
      toYm: '2025-03',
      startAmount: 30000,
      monthlyStep: 2600,
      empresa: 'METALURGICA CENTRAL SA',
      cuit: '30777888990'
    }).map((row, idx) => ({ ...row, monto: idx % 9 === 0 ? row.monto * 1.8 : row.monto })),
    parametros: {
      indiceObjetivo: 'MIXTO',
      metodoCalculo: 'avanzado',
      incluirPBU: true,
      topeLegal: true,
      estrategiaJuridica: {
        habilitarFallos: true,
        tasaInteres: 'ACTIVA_BNA',
        aplicarPrescripcion: true
      }
    }
  }),
  makePayload({
    caseId: 'SIM-BASE-03',
    label: 'Dependencia ordinaria viable (120 exactos)',
    expediente: withLegalMilestones({
      cuilCuit: '20000000009',
      nombre: 'Elena',
      apellido: 'Quiroga',
      sexo: 'F',
      fechaNacimiento: '1962-02-03',
      fechaCese: '2025-03-01',
      haberActual: 240000,
      jurisdiccion: 'CABA_FEDERAL',
      fallo: 'RIPTE',
    }),
    historialLaboral: dependenciaOrdinaria,
    parametros: {
      indiceObjetivo: 'RIPTE',
      metodoCalculo: 'base',
      incluirPBU: true,
      topeLegal: true,
    },
  }),
  makePayload({
    caseId: 'SIM-ADV-04',
    label: 'Mixto viable (dep + autonomo) ISBIC',
    expediente: withLegalMilestones({
      cuilCuit: '23000000019',
      nombre: 'Carlos',
      apellido: 'Mendez',
      sexo: 'M',
      fechaNacimiento: '1959-10-12',
      fechaCese: '2025-03-01',
      haberActual: 270000,
      jurisdiccion: 'PBA',
      fallo: 'ISBIC',
      tieneMoratoria: true,
    }),
    historialLaboral: [...mixtoViableDep, ...mixtoViableAuto].sort((a, b) => String(b.periodo).localeCompare(String(a.periodo))),
    parametros: {
      indiceObjetivo: 'ISBIC',
      metodoCalculo: 'avanzado',
      incluirPBU: true,
      topeLegal: true,
      estrategiaJuridica: {
        habilitarFallos: true,
        tasaInteres: 'ACTIVA_BNA',
        aplicarPrescripcion: true,
      },
    },
  }),
  makePayload({
    caseId: 'SIM-ADV-05',
    label: 'Docente puro viable (Dec. 137/05)',
    expediente: withLegalMilestones({
      cuilCuit: '24000000007',
      nombre: 'Patricia',
      apellido: 'Luna',
      sexo: 'F',
      fechaNacimiento: '1963-07-18',
      fechaCese: '2025-03-01',
      haberActual: 260000,
      jurisdiccion: 'CABA_FEDERAL',
      fallo: 'RIPTE',
      esDocente: true,
      datosDocentes: {
        cargoCese: 'DOCENTE TITULAR',
        sueldoBrutoCargoCese: 640000,
        mesesEnCargoContinuos: 84,
        mesesEnCargoAlternados: 0,
      },
    }),
    historialLaboral: docentePuro,
    parametros: {
      indiceObjetivo: 'RIPTE',
      metodoCalculo: 'avanzado',
      incluirPBU: true,
      topeLegal: true,
      estrategiaJuridica: {
        habilitarFallos: true,
        tasaInteres: 'PASIVA_BCRA_A14290',
        aplicarPrescripcion: true,
      },
    },
  }),
  makePayload({
    caseId: 'SIM-ADV-06',
    label: 'Autonomo puro viable con mejora',
    expediente: withLegalMilestones({
      cuilCuit: '27000000006',
      nombre: 'Marta',
      apellido: 'Pereyra',
      sexo: 'F',
      fechaNacimiento: '1961-05-26',
      fechaCese: '2025-03-01',
      haberActual: 230000,
      jurisdiccion: 'CABA_FEDERAL',
      fallo: 'RIPTE',
    }),
    historialLaboral: autonomoPuro,
    parametros: {
      indiceObjetivo: 'RIPTE',
      metodoCalculo: 'avanzado',
      incluirPBU: true,
      topeLegal: true,
      estrategiaJuridica: {
        habilitarFallos: true,
        tasaInteres: 'ACTIVA_BNA',
        aplicarPrescripcion: true,
      },
    },
  })
]

export function getSimulationCaseById(caseId) {
  return SIMULATION_CASES.find((item) => item.meta.caseId === caseId) || null
}
